import { atom } from "recoil";

export const addStateCarrierProgram = atom({
  key: "addStateCarrierProgram",
  default: false,
});
export const editStateCarrierProgram = atom({
  key: "editStateCarrierProgram",
  default: false,
});
export const selectedCarrierPrograms = atom({
  key: "selectedRowsStateCarrierProgram",
  default: [],
});
